
import api from '@/api/proxyWeb/archives'

export default {

    get({ commit }, id) {

        commit('setCurrentArchive', null)
        
        return api.get(id)
            .then(archive => {
                commit('setCurrentArchive', archive)
            })
    },

    getAll({ commit, rootState }) {

        commit('setArchives', null)
        
        let params = {
            client_id: rootState.clients.currentId
        }

        return new Promise(resolve => {
        
            Promise.all([
                api.count(params),
                api.list(params)
            ])
            .then( ([ count, archives ]) => {
                commit('setCount', count)
                commit('setArchives', archives)
                resolve(archives)
            })
        })
    },

    getNext({ commit, state, rootState }) {

        let params = {
            client_id: rootState.clients.currentId,
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(archives => {
                commit('setNextArchives', archives)
            })
    }
}